var apiConstants = {
    METHODS: [

        {
            rel: 'http://api.dealer-fx.com/docs/rels/customer-vehicles',
            methodType: 'GET',
            methodName: 'getVehicles',
            dataRootPath: 'vehicles',
            additionalData: ['serviceContracts']
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/vehicle',
            methodType: 'GET',
            config: { ignoreErrors: true },
            methodName: 'decodeVin'
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/vehicle',
            methodType: 'GET',
            methodName: 'getVehicle'
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/telematics-vehicle',
            methodType: 'GET',
            methodName: 'getVehicleTelematics'
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/alert-placeholders',
            methodType: 'GET',
            methodName: 'getAlertPlaceholders',
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/protection-contracts',
            methodType: 'GET',
            methodName: 'getProtectionPlans',
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/car-model',
            methodType: 'GET',
            methodName: 'resolveModel'
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/customer-verify',
            methodType: 'POST',
            methodName: 'verify'
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/customers-find',
            methodType: 'GET',
            methodName: 'findCustomers',
            dataRootPath: 'customerPreviews'
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/customers-match',
            methodType: 'POST',
            methodName: 'matchCustomer'
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/match-customer',
            methodType: 'POST',
            methodName: 'CustomerMatch'
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/manufacturers',
            methodType: 'GET',
            methodName: 'getManufacturers',
            dataRootPath: 'manufacturers'
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/manufacturer',
            methodType: 'GET',
            methodName: 'getManufacturer'
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/manufacture-year-collection',
            methodType: 'GET',
            methodName: 'getYears',
            dataRootPath: 'years'
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/manufacture-year',
            methodType: 'GET',
            methodName: 'getYear'
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/car-model-collection',
            methodType: 'GET',
            methodName: 'getModels',
            dataRootPath: 'models'
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/car-model',
            methodType: 'GET',
            methodName: 'getModel'
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/transmission-collection',
            methodType: 'GET',
            methodName: 'getTransmissions',
            dataRootPath: 'transmissions'
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/transmission',
            methodType: 'GET',
            methodName: 'getTransmission'
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/cylinder-collection',
            methodType: 'GET',
            methodName: 'getEngines',
            dataRootPath: 'cylinders'
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/cylinder',
            methodType: 'GET',
            methodName: 'getEngine'
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/drive-collection',
            methodType: 'GET',
            methodName: 'getDriveTrains',
            dataRootPath: 'drives'
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/drive',
            methodType: 'GET',
            methodName: 'getDriveTrain'
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/dealer-info',
            methodType: 'GET',
            methodName: 'getDealer'
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/transportation-option-collection',
            methodType: 'GET',
            methodName: 'getTransportationOptions',
            dataRootPath: 'options'
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/transportation-option',
            methodType: 'GET',
            methodName: 'resolveTransportationOption'
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/service-department-time-segment-collection',
            methodType: 'GET',
            methodName: 'getAvailableTime'
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/service-department-member-time-segment-collection',
            methodType: 'GET',
            methodName: 'getAvailableTime'
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/repair-service-collection',
            methodType: 'GET',
            methodName: 'resolveCustomerConcernsServices',
            dataRootPath: 'services'
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/required-service-collection',
            methodType: 'GET',
            methodName: 'resolveFactoryRequiredServices',
            dataRootPath: 'services',
            additionalData: ['affectiveMileage', 'serviceContracts']
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/recommended-service-collection',
            methodType: 'GET',
            methodName: 'resolveDealerRecommendedServices',
            dataRootPath: 'services'
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/recall-collection',
            methodType: 'GET',
            methodName: 'resolveRecalls',
            dataRootPath: 'recalls'
        },        
        {
            rel: 'http://api.dealer-fx.com/docs/rels/service-advisor-collection',
            methodType: 'GET',
            methodName: 'getAdvisers',
            dataRootPath: 'serviceAdvisors'
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/service-advisor',
            methodType: 'GET',
            methodName: 'getAdviser'
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/service-department',
            methodType: 'GET',
            methodName: 'getDepartment'
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/maintenance-interval-collection',
            methodType: 'GET',
            methodName: 'getMaintenancePeriod'
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/appointment',
            methodType: 'GET',
            methodName: 'getAppointment',
            config: { timeout: 60000 },
            self: [{
                methodType: 'DELETE',
                methodName: 'removeAppointment'
            }, {
                methodType: 'PUT',
                methodName: 'updateAppointment'
            }]
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/appointment-collection',
            methodType: 'POST',
            methodName: 'createAppointment'
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/appointment-collection',
            methodType: 'GET',
            methodName: 'getAppointments'
        },
        {
            rels: ['http://api.dealer-fx.com/docs/rels/service summary',
                'http://api.dealer-fx.com/docs/rels/service-summary'],
            methodType: 'POST',
            methodName: 'getAppointmentSummary'
        },
        {
            rels: ['http://api.dealer-fx.com/docs/rels/maintenance menu',
                'http://api.dealer-fx.com/docs/rels/maintenance-menu'],
            methodType: 'POST',
            methodName: 'getMaintenanceMenu'
        },
        {
            rels: ['http://api.dealer-fx.com/docs/rels/maintenance menu',
                'http://api.dealer-fx.com/docs/rels/maintenance-menu'],
            methodType: 'POST',
            methodName: 'createAppointment'
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/maintenance-menu',
            methodType: 'POST',
            methodName: 'maintenanceMenu'
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/service-department-collection',
            methodType: 'POST',
            methodName: 'getDepartment',
            skipLinkTemplate: 'http://api.dealer-fx.com/docs/rels/department-transportation-option-collection'
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/localization',
            methodType: 'GET',
            methodName: 'getMessage'
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/localization-collection',
            methodType: 'GET',
            methodName: 'getMessages'
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/department-transportation-option-collection',
            methodType: 'GET',
            methodName: 'getTransportationOptions',
            dataRootPath: 'options'
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/maintenance-service-category-collection',
            methodType: 'GET',
            methodName: 'getServiceCategoryCollection',
        },
        {
            rel: 'http://api.dealer-fx.com/docs/rels/appointment-collection',
            methodType: 'PUT',
            methodName: 'updateMVPServiceContract'
        }
    ],
    SERVICECONTRACTS: {
        'Other': 0,
        'TireRotaion': 1,
        'OilFilterChange': 2
    },
    SERVICEPRICE: {
        'Zero': 0
    }
};

module.exports = apiConstants;


